import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconPerspective = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeMiterlimit: 1.4,
	clipRule: "evenodd",
	viewBox: "0 0 1024 1025",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			d: "M-100.435-99.984h1224.97v1224.97h-1224.97z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 67.82,
			d: "m15356.5 319.324 298.5 298.543",
			transform: "matrix(1.20065 -.28354 .35477 1.18157 -18503.402 4626.63)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 86.13072000000001,
			d: "M512.062 908.683V107.208M185.364 729.177V295.825"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 67.82,
			d: "m15356.5 319.324 298.5 298.543",
			transform: "matrix(-1.20065 -.28354 -.35477 1.18157 19527.56 4626.63)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 67.82,
			d: "m15364.8 290.962 298.6 298.543",
			transform: "matrix(1.20065 .28354 .35477 -1.18157 -18503.402 -3637.517)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 67.82,
			d: "m15364.8 290.962 298.6 298.543",
			transform: "matrix(-1.20065 .28354 -.35477 -1.18157 19527.56 -3637.517)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 86.13072000000001,
			d: "M838.749 729.177V295.825"
		})
	]
});
export default SvgIconPerspective;
